import { Box, Td } from "@chakra-ui/react";
import { isNumber } from "lodash";
import { ReceivedBseBidDto, WinningProductGroupBidsDto } from "../../../../../autogen/bff-api";
import { formatNumber } from "../../../../../common/formatting/formatNumber";
import { Product, ProductGroup } from "../../../../../common/types";
import { useIsAwardedProduct } from "./useIsAwardedProduct";
import { useIsBestProductPrice } from "./useIsBestProductPrice";
import { useProductBid } from "./useProductBid";
import { useBidSelection } from "./useSelectProductBids";
import { useTotalProductPrice } from "./useTotalProductPrice";

export const SelectPriceCell = ({
  bid,
  bids,
  product,
  group,
  selectedBids,
}: {
  bid: ReceivedBseBidDto;
  bids: ReceivedBseBidDto[];
  product: Product;
  group: ProductGroup;
  selectedBids: WinningProductGroupBidsDto[];
}) => {
  const { selectBid, removeBid, selectionLocked } = useBidSelection();
  const productBid = useProductBid({ productId: product.id, groupId: group.id, bid });
  const isBestProductPrice = useIsBestProductPrice({ bidId: bid.id, productId: product.id, group, bids });
  const isAwardedProduct = useIsAwardedProduct({ group, productId: product.id, bidId: bid.id, bids, selectedBids });
  const totalProductPrice = useTotalProductPrice({ productId: product.id, group, bid });

  return (
    <Td
      key={bid.id}
      position="relative"
      textAlign="right"
      verticalAlign="top"
      cursor={!selectionLocked && productBid && isNumber(totalProductPrice) ? "pointer" : "default"}
      color={isBestProductPrice ? "green.500" : "yellow.500"}
      fontWeight={isAwardedProduct ? "bold" : "normal"}
      pt="3"
      onClick={() => {
        if (selectionLocked || !isNumber(totalProductPrice)) return;
        if (isAwardedProduct) removeBid({ bid, productId: product.id, group });
        else selectBid({ bid, productId: product.id, group });
      }}
    >
      <Box
        width="40"
        height="full"
        rounded="md"
        px="4"
        py="1"
        border={isAwardedProduct ? "1px" : "none"}
        borderColor="gray.300"
        float="right"
      >
        {formatNumber(totalProductPrice)}
      </Box>
    </Td>
  );
};
